import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 ${dark ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'} ${className}`} data-id="element-387">
      
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-388">{children}</div>
    </section>;
}